/* eslint-disable import/order */
import Vue from 'vue';
import VueBus from 'vue-bus';
// import './init/cesium';
import './init/element';
import './init/router';
import './init/theme';
import './init/protheme';
import './init/ExAxios';
import './init/loginInterceptor';
import root from './root/root';
import router from './root/router';
import i18n from './i18n/index';
import VXETable from 'vxe-table';
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx';

// 引入vxe-table高级表格
import 'xe-utils';
import 'exceljs';
import 'vxe-table/lib/style.css';
// 引入Font Awesome字体库和css框架
import 'font-awesome/css/font-awesome.min.css';
// 可复用列表
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
// 引入复制功能
import VueClipboard from 'vue-clipboard2';
import 'clipboard';
// 引入Mixin
import Mixin from '@/page/taskPage/common/Mixin';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';

// 权限按钮指令
import has from './root/directives/has';
//菜单权限函数，当不适合用v-permission时用这个
import { checkPermission } from './root/directives/has'
Vue.prototype.$checkPermission = checkPermission


import store from './store/index';
import './root/permission';
// 导入自动注册组件
import './plugins/global-components'; // 全局引入样式

// @/src/components/text-tormat/text-format.vue
import textFormat from './components/text-format/text-format.vue';
// 引入$checkPermission权限插件,可在组件中通过 this.$checkPermission() 调用
import PermissionPlugin from './plugins/PermissionPlugin';
Vue.use(PermissionPlugin);



// 引入全局监听事件工具，使用方式this.$bus.emit()、this.$bus.on()、
Vue.use(VueBus);
Vue.use(VueVirtualScroller);

Vue.use(VueAwesomeSwiper);

Vue.mixin(Mixin);

Vue.directive('has', has);

Vue.use(VXETable);
Vue.use(VXETable).use(VueClipboard);
VXETable.use(VXETablePluginExportXLSX);

// 给 vue 实例挂载内部对象，例如：
Vue.prototype.$XModal = VXETable.modal;
Vue.prototype.$XPrint = VXETable.printmodal;
Vue.prototype.$XSaveFile = VXETable.saveFilemodal;
Vue.prototype.$XReadFile = VXETable.readFilemodal;

Vue.component('IconSvg', require('./components/IconSvg.vue').default);
Vue.component('SelectTree', require('./components/SelectTree.vue').default);

Vue.component('textFormat', textFormat);

new Vue({
    ...root,
    router,
    store,
    i18n,
}).$mount('#app');

// 用于调试信息
window.doLog = (log) => {
    window.log = log;
};

window.logInfo = (...args) => {
    if (window.log) {
        console.log(...args);
    }
};
